import { BoxProps } from "@chakra-ui/react";

import { themeStore } from "@/stores/theme";

function getInputProps(): BoxProps {
  const { inputColor } = themeStore.styles;
  return {
    border: "1px",
    borderRadius: "0px",
    borderColor: "transparent",
    color: inputColor,
    fontSize: "12px",
    _hover: {
      borderColor: "#ddd",
    },
    _active: {
      borderColor: "#3fc9a8",
    },
    _focus: {
      borderColor: "#3fc9a8",
    },
  };
}

export default getInputProps;

export const getFillInputProps = (): BoxProps => {
  const { textColor, filledInputBgColor, borderRadius } = themeStore.styles;
  return {
    border: "none",
    color: textColor,
    bg: filledInputBgColor,
    borderRadius,
    fontSize: "16px",
  };
};
